import { Box, Button, Paper, Typography, useTheme } from "@mui/material";
import {
  authLogoStyles,
  authPageContainerStyles,
  authPaperStyles,
  authTitleStyles,
} from "../styles/commonStyles";
import logoGreen from "../assets/images/logo_smaart_green.png";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router";
import ForgotPasswordForm from "../components/forms/forgotPasswordForm.component";

const ForgotPasswordPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate("/login");
  };

  return (
    <Box sx={authPageContainerStyles(theme)}>
      <Paper sx={authPaperStyles}>
        <Box
          display="flex"
          width="100%"
          alignItems="center"
          justifyContent="start"
        >
          <Button
            startIcon={<ArrowBack sx={{ fontSize: "12px" }} />}
            size="small"
            sx={{ textTransform: "none", fontSize: "12px" }}
            onClick={handleBackClick}
          >
            Indietro
          </Button>
        </Box>
        <Box sx={authTitleStyles}>PASSWORD DIMENTICATA</Box>
        <Box
          component="img"
          src={logoGreen}
          alt="Smaart Logo"
          sx={authLogoStyles}
        />
        <Box width="100%">
          <Typography fontWeight={400} fontSize="12px">
            Scrivi il tuo indirizzo email, riceverai un link per reimpostare la
            password
          </Typography>
        </Box>
        <ForgotPasswordForm />
      </Paper>
    </Box>
  );
};

export default ForgotPasswordPage;
